import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import { Card, Stack, CardHeader, CardContent, Checkbox } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialBox from "../../components/MaterialBox";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialSelect from "../../components/MasterSelect";
import Grid from "@mui/material/Grid2";
import { useLoading } from "../../context/loading";
import Swal from "sweetalert2";

const ApprovalWorkFlowManagement = () => {
  
  let flowlist = [
    {
      label: "Leave Approval",
      value: "Leave Approval",
    },
    {
      label: "Regularization Approval",
      value: "Regularization Approval",
    },
    {
      label: "Permission Approval",
      value: "Permission Approval",
    },
    {
      label: "Work From Home Approval",
      value: "Work From Home Approval",
    },
    {
      label: "Exit Formalities",
      value: "Exit Formalities",
    },
  ];

  let flowlevel = [
    {
      label: "Level 1",
      value: 1,
    },
    {
      label: "Level 2",
      value: 2,
    },
    {
      label: "Level 3",
      value: 3,
    },
    {
      label: "Level 4",
      value: 4,
    },
    {
      label: "Level 5",
      value: 5,
    },
  ];

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [approvalList, setApprovalList] = useState([]);
  const [update, setUpdate] = useState(false);
  const [approval, setApproval] = useState({
    approvalfor: "",
    approvallevel: "",
    approvalforStatus: "unchecked",
    approvallevelStatus: "unchecked",
    hrApproval: true,
    id: "",
  });
  const { setCirleLoading } = useLoading();


    console.log(approval,"23eedd");
    
  const approvalListTable = {
    columns: [
      {
        field: "sno",
        headerName: "S.No",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "Approvallevel",
        headerName: "Approvallevel",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "ApprovalFor",
        headerName: "ApprovalFor",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "hrApproval",
        headerName: "HrApproval",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],

    rows: approvalList?.map((leave, index) => ({
      sno: index + 1,
      id: leave.id,
      Approvallevel: leave.approvelLevel,
      ApprovalFor: leave?.approvalScreen,
      hrApproval: <>{leave?.hrApproval ? "True" : "False"}</>,
    })),
  };

  useEffect(() => {
    getApprovalList();
  }, []);

  //get Approval List Api
  const getApprovalList = async () => {
    setCirleLoading(true);
    const query = `
    query all_approval_workflow{  
allApprovalWorkflow{  
data {  
id  
approvalScreen  
approvelLevel  
hrApproval  
}  
message  
success  
error  
}  
} 
      `;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const approvalList = response?.data?.data?.allApprovalWorkflow?.data;
      setApprovalList(approvalList);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  //get approval work flow by approval name
  const getdata = async (data) => {
    setCirleLoading(true);
    const query = `
    query get_approval_workflow_by_approval_screen($approval_screen: String!){ getApprovalWorkflowByApprovalScreen(approvalScreen: $approval_screen){  
data{ 
 id  
approvalScreen  
approvelLevel  
hrApproval  
}  
message  
success  
error  
}  
} 
    `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { approval_screen: data.value },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data?.getApprovalWorkflowByApprovalScreen?.success) {
        const datas =
          response?.data?.data?.getApprovalWorkflowByApprovalScreen?.data[0];
         console.log(datas?.approvelLevel,"aplev");

           const approvallevel = datas?.approvelLevel || null

           console.log(datas,"jhnh4");
           
         
        setApproval((prevApproval) => ({
          ...prevApproval,
          approvallevelStatus:"unchecked",
          approvallevel:null,
          approvallevel: {
            value: approvallevel,
            label: `Level ${approvallevel}`,
          },
          approvallevelStatus: approvallevel?"success":"unchecked",
          id: datas?.id,
          hrApproval: datas?.hrApproval,
        }));

        setUpdate(true);
      } else {
        setApproval((prevApproval) => ({
          ...prevApproval,
          approvallevel: "",
          approvallevelStatus:"unchecked",
          hrApproval: true,
        }));
        setUpdate(false);
      }
    } catch (error) {
      console.log("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //Add and edit api integration
  const onSubmit = async () => {
    setCirleLoading(true);
    const mutation = `mutation create_or_update_approval_workflow($input: CreateOrUpdateApprovalWorkFlowInput!) { 
createOrUpdateApprovalWorkflow(input: $input) {  
message  
success  
error  
}  
} `;
    let input = {
      approvalScreen: approval.approvalfor.value || null,
      approvelLevel: approval.approvallevel.value || null,
      hrApproval: approval.hrApproval,
    };
    if (update) {
      input.id = approval.id;
    }
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: mutation,
          variables: {
            input: input,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data?.createOrUpdateApprovalWorkflow?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response?.data?.data?.createOrUpdateApprovalWorkflow?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response?.data?.data?.createOrUpdateApprovalWorkflow?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
      getApprovalList();
    } catch (err) {
      console.log(err);
    } finally {
      setCirleLoading(false);
    }
  };

  //Disabled Function
  const disabledHandel = () => {
    let temp = false;
    if (
      approval?.approvalforStatus == "success" &&
      approval?.approvallevelStatus == "success"
    ) {
      temp = false;
    } else {
      temp = true;
    }
    return temp;
  };

  // Onchange Function
  const handleApproval = (event, selectEvent) => {
    let approvalState = { ...approval };

    if (event?.target === undefined && selectEvent) {
      approvalState[selectEvent.name] = event;
      approvalState[selectEvent.name + "Status"] = "success";
      if (selectEvent.name == "approvalfor") {
        getdata(event);
      }
    }

    setApproval(approvalState);
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Approval Workflow List
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "0vh" }}>
          <MaterialBox>
            <Grid container spacing={1} alignItems="center">
              <Grid size={{ xs: 5, sm: 4, md: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Approval for
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="approvalfor"
                  value={approval?.approvalfor}
                  onChange={handleApproval}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  options={flowlist}
                  customStyles={{
                    optionPadding: 2,
                    optionMinWidth: 150,
                  }}
                  error={approval.approvalforStatus === "error"}
                  success={approval.approvalforStatus === "success"}
                  // isLoading={isStateLoading}
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4, md: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Approval levels
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="approvallevel"
                  value={approval?.approvallevel}
                  onChange={handleApproval}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  options={flowlevel}
                  customStyles={{
                    optionPadding: 2,
                    optionMinWidth: 150,
                  }}
                  error={approval.approvallevelStatus === "error"}
                  success={approval.approvallevelStatus === "success"}
                />
              </Grid>

              <Grid
                size={{ xs: 5, sm: 4, md: 4, lg: 4 }}
                style={{ marginTop: "30px" }}
              >
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Hr Approval
                  </MaterialTypography>
                </MaterialBox>
                <Checkbox
                  checked={approval?.hrApproval}
                  onChange={() =>
                    setApproval({
                      ...approval,
                      ["hrApproval"]: !approval?.hrApproval,
                    })
                  }
                  sx={{
                    color: "#424242",
                    "&.Mui-checked": {
                      color: "#1976d2",
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: "18px",
                      border: "1px solid #424242",
                      borderRadius: "4px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox sx={{ display: "flex", justifyContent: "end" }}>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={disabledHandel()}
              onClick={onSubmit}
            >
              {update ? "Update" : "Submit"}
            </MaterialButton>
          </MaterialBox>
        </CardContent>
        <MaterialDataGrid
          noSearch={true}
          rows={approvalListTable.rows}
          columns={approvalListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Approval Workflow"
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Approval details. Click on the "Add
                  Approval Workflow" button to start adding Approval details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ApprovalWorkFlowManagement;
